export default __webpack_public_path__ + "static/nuno-4064d082dc51596cc9e99dc9b07bfce2.jpg";